import React from 'react';
import ReactDOM from 'react-dom/client';
import LandingPage from './digital-detox-camp-landing';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>
);


